import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeClosedIcon, EyeIcon } from '../../../assets/icons';
import { Loader } from '../../../components';
import { useSignup } from '../../../hooks';

const Signup = ({ changeAuth }) => {
  const [user, setUser] = useState({
    email: '',
    password: '',
    name: '',
  });
  const [showPsw, setShowPsw] = useState(false);
  const { signup, isPending, error, cleanup } = useSignup();

  const handleSubmit = (e) => {
    e.preventDefault();
    signup(user.email, user.password, user.name);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  useEffect(() => {
    return () => {
      if (isPending) {
        cleanup();
      }
    };
  });
  return (
    <form className="auth__form" onSubmit={handleSubmit}>
      <h2 className="title">Sign Up</h2>

      <p>
        Please sign up to find your dream home, or to continue without
        registration click{' '}
        <Link to="/" className="auth-link">
          here
        </Link>
        .
      </p>

      <label>
        <span>Name:</span>
        <div className="input-field">
          <input
            type="text"
            name="name"
            onChange={handleChange}
            value={user.name}
            required
          />
        </div>
      </label>

      <label>
        <span>Email Address:</span>
        <div className="input-field">
          <input
            type="email"
            name="email"
            onChange={handleChange}
            value={user.email}
            required
          />
        </div>
      </label>

      <label>
        <span>Password:</span>
        <div className="input-field">
          <input
            type={`${showPsw ? 'text' : 'password'}`}
            name="password"
            onChange={handleChange}
            value={user.password}
            required
          />
          {showPsw ? (
            <EyeIcon onClick={() => setShowPsw(false)} />
          ) : (
            <EyeClosedIcon onClick={() => setShowPsw(true)} />
          )}
        </div>
      </label>

      {error && <p className="error">{error}</p>}

      <div className={`btn-container ${isPending && 'disabled'}`}>
        <button className="btn" disabled={isPending}>
          {isPending ? <Loader white={true} small={true} /> : 'Signup'}
        </button>
      </div>

      <span className="auth__change">
        Already have an account? login <span onClick={changeAuth}>here</span>
      </span>
    </form>
  );
};

export default Signup;
